<template>
  <div class="w-full text-center">
    <div class="content">
      <div style="margin-bottom: 50px" class="flex flex-wrap mb-4">
        <div class="w-full md:w-1/3"></div>
        <div class="w-full md:w-1/3">

          <p class="text-center f-b">
            Hai completato la richiesta della tua carta fisica!
          </p>

          <img
            class="reg-completed-img"
            src="../../assets/images/conto_ok.png"
          />

          <div class="info-box">
            <p class="f-b">
              La tua richiesta è andata a buon fine, abbiamo addebitato sul tuo
              conto il costo di emissione della carta.
            </p>
            <p class="">E adesso?</p>
            <ul class="text-grey">
              <li class="mb-2">
                Riceverai una mail di conferma di emissione della tua carta
              </li>
              <li class="mb-2">
                Entro pochi giorni riceverai la carta fisica all'indirizzo che hai indicato
              </li>
            </ul>
            <p class="mt-5">Nel frattempo puoi continuare a utilizzare la tua carta virtuale per tutti i pagamenti, online e nei negozi fisici!</p>
          </div>
        </div>

      </div>
      <div class="page-footer mt-10">
          <button class="btn" @click="backToInitialView">
            Torna alla schermata iniziale
          </button>
        </div>
    </div>


  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";
export default {
  name: "UpgradeCompleted",

  data() {
    return {
    };
  },
  computed: {
    appReady() {
      return this.$store.state.appReady;
    },
  },
  async mounted() {
    if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    async init() {

    },
    backToInitialView() {
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 150px;
  margin: 20px auto;
}
.info-box {
  text-align: left;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 100px;
  }
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  .card {
    position: relative;
    .card__box {
      width: 300px;
    }
  }
  img {
    width: 200px;
    position: absolute;
    top: -90px;
    left: 100px;
  }
}
</style>
